import React, { useContext } from 'react';
import { DecisionTreeContext } from '../context/decision-tree-context';
import { DecisionTreeCurrentQuestion } from './decision-tree-current-question';

export const DecisionTreeQuestions: React.FC = () => {
  const { currentQuestion, questions } = useContext(DecisionTreeContext);
  return (
    <div
      className={`flex flex-col md:flex-row items-center 
    `}>
      <div
        className={`flex flex-row justify-center h-20 mb-20 md:w-20 md:h-full md:flex-col md:mb-0`}>
        {questions.length > 0 &&
          questions
            .filter((q) => !q.hide)
            .map((q, key) => (
              <div
                className={`flex justify-center items-center mr-6 md:mr-8 md:mb-8 md:mr-0`}
                key={key}>
                <div
                  className={`h-fit w-fit ${
                    q.id === currentQuestion?.id &&
                    'border-blue-500 border-2 border-solid rounded-full'
                  }`}>
                  <span
                    className={`w-4 h-4 m-2 rounded-full border-blue-500 border-2 border-solid flex items-center justify-center text-white ${
                      (q.answer || q.id === currentQuestion?.id) && 'bg-blue-500'
                    }`}></span>
                </div>
              </div>
            ))}
      </div>

      <div className={`flex flex-grow justify-center`}>
        {currentQuestion && <DecisionTreeCurrentQuestion question={currentQuestion} />}
      </div>
    </div>
  );
};
